import React, { useState, useEffect } from 'react';
import { Button, Col, Row, Container } from 'react-bootstrap';
import styles from '../assets/styles/OteviraciDoba.module.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

import { useAuth } from '../contexts/AuthContext';
import { apiFetch } from '../services/apiService';
import { useOpeningHours } from '../contexts/OpeningHoursContext';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// Přidáváme props do komponenty
const OteviraciDoba = ({ type = "forMain" }) => {
    const { content, setContent, fetchOteviraciDoba } = useOpeningHours();

    let Heading = 'h2'; // Inicializujeme proměnnou pomocí let, protože hodnota bude později modifikována

    let visible = true;

    // Rozhodování o typu nadpisu na základě předaného typu
    switch (type) {
        case "forFooter":
            Heading = "h5";
            visible = false;
            break;
        case "forMain":
        default:
            Heading = "h2";
            break;
    }

    const { user } = useAuth();

    const [editMode, setEditMode] = useState(false);

    const handleEdit = () => setEditMode(true);


    useEffect(() => {
        fetchOteviraciDoba();
    }, []);

    const handleSave = async () => {
        try {
            await apiFetch('/api/general/setOteviraciDoba', {
                method: 'POST',
                body: JSON.stringify({ content }),
            });
            setEditMode(false);
            fetchOteviraciDoba();
        } catch (error) {
            console.error('Chyba při ukládání otevírací doby:', error);
        }
    };

    const handleCancel = () => {
        setEditMode(false);
    };

    return (
        <div className='text-center'>
            <Container>
                <header className='position-relative'>
                    <Heading><FontAwesomeIcon icon={faClock} />&nbsp;Otevírací doba</Heading>
                    {user && !editMode && visible && (
                        <Button onClick={handleEdit} className={`btn-albert position-absolute top-50 end-0 translate-middle-y`}>
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    )}
                </header>


                {user && editMode && (
                    <Container>
                        <CKEditor
                            editor={ClassicEditor}
                            data={content}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setContent(data); // Aktualizace stavu s daty editoru
                            }}
                        />
                        <div className="d-flex justify-content-between mt-2">
                            <Button variant="outline-danger" onClick={handleCancel}>
                                Zrušit
                            </Button>
                            <Button variant="outline-success" onClick={handleSave} className='ms-2'>
                                Uložit
                            </Button>
                        </div>
                    </Container>
                )}
            </Container>

            {user && editMode && (
                <div className="my-4" style={{ height: '2px', backgroundColor: '#4c4c4c' }}></div> // Vlastní oddělovač
            )}

            <Container className={styles.oteviraciDobaWrap}>
                <Row className='justify-content-center'>
                    <Col>
                        <article dangerouslySetInnerHTML={{ __html: content }} className={styles.oteviraciDoba}></article>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default OteviraciDoba;